import React, { useState } from 'react';
import clsx from 'clsx';
import CmtDropdownMenu from '../../../../@coremat/CmtDropdownMenu';
// import CmtAvatar from '../../../../@coremat/CmtAvatar';
import { Box } from '@material-ui/core';
import { alpha, makeStyles } from '@material-ui/core/styles';
import PersonIcon from '@material-ui/icons/Person';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { useDispatch } from 'react-redux';
// import { AuhMethods } from '../../../../services/auth';
// import { CurrentAuthMethod } from '../../../constants/AppConstants';
import { CULogOut } from '../../../../redux/actions/ClaveUnicaActions';
import { AccountCircle } from '@material-ui/icons';
import { useHistory } from 'react-router-dom';
import { URL_DEFAULT } from 'config/config';
import ProfileModal from '@jumbo/components/custom/ProfileModal';

const useStyles = makeStyles(theme => ({
  profileRoot: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingLeft: 10,
    position: 'relative',
    [theme.breakpoints.up('md')]: {
      paddingLeft: 20,
    },
    '&:before': {
      content: '""',
      position: 'absolute',
      left: 0,
      top: 2,
      zIndex: 1,
      height: 35,
      width: 1,
      backgroundColor: alpha(theme.palette.common.dark, 0.15),
    },
  },
  icon: {
    fontSize: 'xx-large',
  },
}));

const actionsList = [
  {
    icon: <PersonIcon />,
    label: 'Perfil',
  },
  {
    icon: <ExitToAppIcon />,
    label: 'Cerrar Sesión',
  },
];

const UserDropDown = () => {

  const [showProfileModal, setShowProfileModal] = useState(false)

  const classes = useStyles();
  const dispatch = useDispatch();
  let history = useHistory();

  const openModal = () => {
    setShowProfileModal(true)
  }

  const closeModal = () => {
    setShowProfileModal(false)
  }

  const onItemClick = item => {
    if (item.label === 'Cerrar Sesión') {
      dispatch(CULogOut());
      history.push(URL_DEFAULT);
    }
    if (item.label === 'Perfil') {
      openModal()
    }
  };

  return (
    // <Box className={clsx(classes.profileRoot, 'Cmt-profile-pic')}>
    //   <CmtDropdownMenu
    //     onItemClick={onItemClick}
    //     TriggerComponent={<CmtAvatar size="small" src={'https://via.placeholder.com/150'} />}
    //     items={actionsList}
    //   />
    // </Box>
    <Box className={clsx(classes.profileRoot, 'Cmt-profile-pic')}>
      <ProfileModal
        openDialog={showProfileModal}
        close={closeModal}
      />
      <CmtDropdownMenu
        onItemClick={onItemClick}
        TriggerComponent={<AccountCircle className={classes.icon} />}
        items={actionsList}
      />
    </Box>
  );
};

export default UserDropDown;
